export interface InputFieldClearButtonData<TValue> {
  showOnChange?: boolean; // Show if value is changed from original
  showOnNotEmpty?: boolean; // Show if value is not empty
  hideChildrenOnShown?: boolean; // Hide children if clear is active
  onClear?: (newValue: undefined | TValue | TValue[]) => void;

  value?: TValue | TValue[];
  initialValue?: TValue | TValue[];
  multiple?: boolean;

  componentOnHidden?: React.ReactNode;
}

export interface InputFieldClearButtonProps<TValue> extends InputFieldClearButtonData<TValue> {}
